<template>
  <div class="rounded-t-lg text-center md:text-left md:pl-5 py-3 w-full text-white bg-green-600 border-t border-b border-none border-green-300">
    <div class="leading-normal text-xs md:text-sm font-bold">
      {{ exam.title }}
    </div>
    <div class="leading-normal text-xs md:text-sm font-bold">
      {{ exam.subtitle }}
    </div>
    <div class="leading-normal text-xs md:text-sm font-bold">
      {{ tanggal(exam.started_at) }} - {{ tanggal(exam.ended_at) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    exam: {
      required: true,
      type: Object,
    }
  },
  mounted() {
    this.$nextTick(function () {
      // this.$store.commit('setCurrentPath', '');
    })
  },
  methods: {
    tanggal,
  },
}
</script>
